import {
  selectAuth,
  selectAuthStatus,
  selectIsAuthenticated,
  selectIsLoading,
  selectIsReady,
  selectMyId,
  selectUser,
} from 'features/auth/authSlice';
import { useSelector } from 'react-redux';

export function useAuth() {
  return useSelector(selectAuth);
}

export function useAuthStatus() {
  return useSelector(selectAuthStatus);
}

export function useAuthUser() {
  return useSelector(selectUser);
}

export function useMyId() {
  return useSelector(selectMyId);
}

export function useIsAuthenticated() {
  return useSelector(selectIsAuthenticated);
}

export function useIsAuthLoading() {
  return useSelector(selectIsLoading);
}

export function useIsAuthReady() {
  return useSelector(selectIsReady);
}
